import { FC, memo } from "react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";

interface NotificationBadgeProps {
  important?: boolean;
  broadcast?: boolean;
  className?: string;
}

export const NotificationBadge: FC<NotificationBadgeProps> = memo(
  ({ important, broadcast, className }) => {
    if (!important && !broadcast) return null;

    return (
      <div className={cn("flex items-center gap-1", className)}>
        {important && (
          <Badge variant="destructive" className="text-xs font-medium">
            重要
          </Badge>
        )}
        {broadcast && (
          <Badge variant="secondary" className="text-xs font-medium">
            广播
          </Badge>
        )}
      </div>
    );
  },
);
